<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { CheckCircle2, Ticket } from 'lucide-vue-next'

const props = defineProps<{
    total: number
    validated: number
}>()

const { t } = useI18n()

const validatedPct = computed(() => {
    if (props.total === 0) return null
    return (props.validated / props.total) * 100
})

function fmt(n: number): string {
    return n.toLocaleString('cs-CZ')
}

function fmtPct(p: number): string {
    return p.toLocaleString('cs-CZ', { minimumFractionDigits: 1, maximumFractionDigits: 1 })
}
</script>

<template>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div class="bg-white border border-gray-200 rounded-12 p-5">
            <div class="flex items-start gap-3">
                <div class="w-10 h-10 rounded-full bg-teal-l flex items-center justify-center shrink-0">
                    <CheckCircle2 class="w-5 h-5 text-teal" />
                </div>
                <div class="flex-1 min-w-0">
                    <div class="text-xs uppercase tracking-wider text-gray-500 font-semibold">
                        {{ t('statistics.kpi.validated') }}
                    </div>
                    <div class="text-3xl font-bold text-ink tabular-nums mt-1">{{ fmt(validated) }}</div>
                    <div v-if="validatedPct !== null" class="text-xs text-gray-500 mt-1">
                        {{ fmtPct(validatedPct) }} % {{ t('statistics.kpi.percentLabel') }}
                    </div>
                </div>
            </div>
        </div>
        <div class="bg-white border border-gray-200 rounded-12 p-5">
            <div class="flex items-start gap-3">
                <div class="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center shrink-0">
                    <Ticket class="w-5 h-5 text-gray-500" />
                </div>
                <div class="flex-1 min-w-0">
                    <div class="text-xs uppercase tracking-wider text-gray-500 font-semibold">
                        {{ t('statistics.kpi.total') }}
                    </div>
                    <div class="text-3xl font-bold text-ink tabular-nums mt-1">{{ fmt(total) }}</div>
                </div>
            </div>
        </div>
    </div>
</template>
